export var EthyleneInjectedConnector = {
    name: "injected",
    provider: window.ethereum,
};
